import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { StaticsServices } from '../../../services/statics';
import { getCurrencySymbol } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MenuServices } from '../../../menu/services';
import { CartaMenuViewPage } from '../../../cartas-menus/carta-menu-view/carta-menu-view';

/**
 * Generated class for the ComboCreatePricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-combo-create-price',
    templateUrl: 'combo-create-price.html',
})
export class ComboCreatePricePage {
    public form: FormGroup;
    combo_uid: string;
    update_state: boolean = false;
    _currency: any = '€';
    type: string = '';
    combo_name: string = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public globals: Globals,
        public menuServices: MenuServices,
        public staticsServices: StaticsServices,
        public translate: TranslateService) {

        this.update_state = this.navParams.get('update');
        this.combo_uid = this.navParams.get('combo_uid');
        this.type = this.navParams.get('type');
        this.combo_name = this.navParams.get('combo_name');
        this._currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');

        this.form = fb.group({
            price: [this.navParams.get('price'), Validators.compose([Validators.required])],
            price_takeaway: [this.navParams.get('price_takeaway')],
            pan_vino_agua_si: [this.navParams.get('pan_vino_agua_si')],
            pan_vino_agua_no: [this.navParams.get('pan_vino_agua_no')],
            refresco_si: [this.navParams.get('refresco_si')],
            refresco_no: [this.navParams.get('refresco_no')],
            cafe_si: [this.navParams.get('cafe_si')],
            cafe_no: [this.navParams.get('cafe_no')],
            extra_price: [this.navParams.get('extra_price')],
            footer: [this.navParams.get('footer')],
        });
        //Si se esta creando el menu, vaciamos el array
        if (!this.update_state) {
            this.menuServices.sections_extra_array_tmp = [];
        }
    }


    submit() {
        if (this.form.valid) {
            //Update
            this.update();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-introduce-precio-menu-continuar'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    update() {
        //Create object extras footer
        var _obj = {
            pan_vino_agua_si: this.form.value.pan_vino_agua_si,
            pan_vino_agua_no: this.form.value.pan_vino_agua_no,
            refresco_si: this.form.value.refresco_si,
            refresco_no: this.form.value.refresco_no,
            cafe_si: this.form.value.cafe_si,
            cafe_no: this.form.value.cafe_no,
        };

        this.menuServices.afs.collection('menus').doc(this.combo_uid).update({
            'price': this.form.value.price,
            'price_takeaway': this.form.value.price_takeaway,
            'footer': this.form.value.footer,
            'extra': this.form.value.extra_price,
            'extras_footer': _obj,
            'updated_at': new Date(),
        }).then(() => {

            //calculate menu cost
            this.staticsServices.updateMenuCost(this.combo_uid);

            this.menuServices.menu_cost = 0;
            this.menuServices.sumands = 0;
            this.menuServices.count_tmp = 0;



            if (this.update_state) {
                this.globals.GAtrackView('Combo', 'Combo - Price extras - Update', this.globals.restaurant.email, 'Create/Update', 'Update price extras', 'Combo', '');
                //staticsServices
                this.staticsServices.changeStateStaticWait(true);
                //pop
                this.navCtrl.pop();
            } else {
                this.globals.GAtrackView('Combo', 'Combo - Price extras - Create', this.globals.restaurant.email, 'Create/Update', 'Create price extras', 'Combo', '');
                //
                this.navCtrl.setRoot(CartaMenuViewPage, {
                    type: 'combo',
                    state: 'new',
                    uid_element: this.combo_uid
                });

            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-price/combo-create-price.ts